export default [{ id: 2, name: 'Admin' }, { id: 3, name: 'User' }];
